import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function DateMoreThanOrEqualsValidator(compareDate = new Date()): ValidatorFn {
  return function DateMoreThanOrEqualsValidate(control: AbstractControl): ValidationErrors {
    if (!control.value) { return null; }
    const date1 = new Date(control.value);

    if (compareDate !== null && date1 > compareDate) {
      return {
        'date_more_than_or_equal': true
      };
    }
    return null;
  };
}
